define('drops/colorPicker/colorPicker',[
    'jquery',
    'lq/drop',
    'jquery.miniColors/jquery.miniColors',
    'lq/required'
], function ($, Drop, miniColors, Required) {
    'use strict';

    var defaults = {
        data: {
            behaviour: 'popup',
            format: 'hex',
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            }
        }
    };

    function ColorPicker(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.$colorPicker = this.createElement()
            .appendTo(this.$element)
            .minicolors('create', this.createData());
        this.value = null;
    }

    Drop.extend(ColorPicker, Drop);

    ColorPicker.typeName = 'ColorPicker';

    ColorPicker.prototype.createElement = function () {
        return this.data.behaviour === 'popup'
            ? $('<input type="hidden" />')
            : $('<input type="text" />');
    };

    ColorPicker.prototype.createData = function () {
        var data = {
            change: this.colorChanged.bind(this)
        };

        if (this.data.behaviour === 'inline')
            data.inline = true;

        return data;
    };

    ColorPicker.prototype.colorChanged = function (value) {
        this.value = this.data.format === 'hex'
            ? value
            : this.$colorPicker.minicolors('rgbString');
        this.triggerEventIfEnabled('changed', this.value);
    };

    ColorPicker.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.piping.required.apply(this);
        Required.prototype.addRemoveRequiredIndicator(this);
        this.applyPosition();
    };

    ColorPicker.prototype.clearValue = function () {
        this.value = '';
        this.$colorPicker
            .minicolors('value', { color: null, opacity: 1 });
    };

    ColorPicker.prototype.setValue = function (update) {
        this.value = update.value;
        this.$colorPicker
            .minicolors('value', { color: update.value, opacity: 1 });
    };

    ColorPicker.prototype.getValue = function () {
        return this.value;
    };

    return ColorPicker;
});
